// IMPORTANT - the file will be replaced by a config map!
// customer/charts/mercator-benefitportal/templates/configmap.yaml
export const environment = {
    production: true,
    apiUrl: "https://api.meinfirmenroller.services.test.esono.net",
    version: (<any>require('../../package.json')).version,
    name: (<any>require('../../package.json')).name,
    mercatorMppShopUrl: "https://mpp-shop.mercator-leasing.de.test.esono.net",
    mlfCompanyId: 1349
};
